import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateContactTitleFailure,
  CreateContactTitleRequest,
  CreateContactTitleSuccess,
  DeleteContactTitleFailure,
  DeleteContactTitleRequest,
  DeleteContactTitleSuccess,
  FetchContactTitleFailure,
  FetchContactTitleRequest,
  FetchContactTitleSuccess,
  FetchContactTitlesFailure,
  FetchContactTitlesRequest,
  FetchContactTitlesSuccess,
  UpdateContactTitleFailure,
  UpdateContactTitleRequest,
  UpdateContactTitleSuccess,
} from './contact-titles.actions'
import { ContactTitlesService } from './contact-titles.service'
import * as ContactTitlesTypes from './contact-titles.types'

@Injectable()
export class ContactTitlesEffects {
  constructor(
    private actions: Actions,
    private contactTitlesService: ContactTitlesService,
    private router: Router,
  ) {}

  FetchContactTitles$ = createEffect(() =>
    this.actions.pipe(
      ofType(ContactTitlesTypes.FETCH_CONTACT_TITLES_REQUEST),
      switchMap((action: FetchContactTitlesRequest) => {
        return this.contactTitlesService
          .fetchContactTitles(action.payload)
          .pipe(
            map((result) => {
              return new FetchContactTitlesSuccess(
                result.data.results,
                result.data.totalCount,
                result.data.filteredCount,
              )
            }),
            catchError((err, caught) => {
              return of(new FetchContactTitlesFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchContactTitle$ = createEffect(() =>
    this.actions.pipe(
      ofType(ContactTitlesTypes.FETCH_CONTACT_TITLE_REQUEST),
      switchMap((action: FetchContactTitleRequest) => {
        return this.contactTitlesService.fetchContactTitle(action.id).pipe(
          map((result) => {
            return new FetchContactTitleSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchContactTitleFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteContactTitle$ = createEffect(() =>
    this.actions.pipe(
      ofType(ContactTitlesTypes.DELETE_CONTACT_TITLE_REQUEST),
      switchMap((action: DeleteContactTitleRequest) => {
        return this.contactTitlesService.deleteContactTitle(action.id).pipe(
          switchMap((result) => {
            return [new DeleteContactTitleSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteContactTitleFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateContactTitle$ = createEffect(() =>
    this.actions.pipe(
      ofType(ContactTitlesTypes.CREATE_CONTACT_TITLE_REQUEST),
      switchMap((action: CreateContactTitleRequest) => {
        return this.contactTitlesService
          .createContactTitle(action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/contact-titles'])
              return [new CreateContactTitleSuccess()]
            }),
            catchError((err, caught) => {
              return of(new CreateContactTitleFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  UpdateContactTitle$ = createEffect(() =>
    this.actions.pipe(
      ofType(ContactTitlesTypes.UPDATE_CONTACT_TITLE_REQUEST),
      switchMap((action: UpdateContactTitleRequest) => {
        return this.contactTitlesService
          .updateContactTitle(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/contact-titles'])
              return [
                new FetchContactTitleRequest(action.id),
                new UpdateContactTitleSuccess(),
              ]
            }),
            catchError((err, caught) => {
              return of(new UpdateContactTitleFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
